import type { Booking } from '@/domain/types';
import type { DepositLevel } from '@/utils/statusTone';

export interface CalendarFilters {
  /** empty = all statuses shown */
  statuses: Booking['status'][];
  /** empty = all deposit levels shown */
  depositLevels: DepositLevel[];
  /** empty = all artists shown */
  artistIds: string[];
  /** hide confirmed + fully-paid tiles so only bookings needing action show */
  hideFilled: boolean;
}

export const EMPTY_CALENDAR_FILTERS: CalendarFilters = {
  statuses: [],
  depositLevels: [],
  artistIds: [],
  hideFilled: false,
};

/**
 * Pure predicate so the calendar and tests share one definition.
 * `depositLevel` is the level of the booking's linked deposit (or 'none').
 */
export function bookingMatchesFilters(
  booking: Booking,
  depositLevel: DepositLevel,
  filters: CalendarFilters,
): boolean {
  if (filters.statuses.length > 0 && !filters.statuses.includes(booking.status)) return false;
  if (filters.depositLevels.length > 0 && !filters.depositLevels.includes(depositLevel)) {
    return false;
  }
  if (filters.artistIds.length > 0 && !filters.artistIds.includes(booking.artistId)) return false;
  if (filters.hideFilled && booking.status === 'confirmed' && depositLevel === 'full') return false;
  return true;
}
